import api from './api';

const state = {
	error: false,
	message: '',
	days: [],
	duties: [],
	basicFitness: null,
	users: {},
};

const getters = {};

const mutations = {
	setError(state, { message }) {
		state.days = [];
		state.error = true;
		state.message = message;
	},

	setDays(state, days) {
		state.days = days;
	},

	setBasicFitness(state, basicFitness) {
		state.basicFitness = basicFitness;
	},

	clearUsers(state) {
		state.users = {};
	},

	setOrUpdateUsers(state, users) {
		const updatedUsers = { ...state.users };
		for (const user of users) {
			updatedUsers[user.id] = user;
		}
		state.users = updatedUsers;
	},

	setDuties(state, duties) {
		state.duties = duties;
	},
};

const actions = {
	async loadDays({ commit, dispatch }) {
		try {
			const result = await api.loadDays();
			commit('setDays', result.data);
		} catch (err) {
			dispatch('setError', err);
		}
	},
	async loadBasicFitness({ commit, dispatch }, dayId) {
		try {
			const result = await api.loadBasicFitness(dayId);
			commit('setBasicFitness', result.data);
		} catch (err) {
			dispatch('setError', err);
		}
	},
	async loadUsers({ commit, state, dispatch }, userIds) {
		const users = {};
		const newUserIds = [];
		for (const userId of userIds) {
			if (state.users[userId]) {
				users[userId] = state.users[userId];
			} else {
				newUserIds.push(userId);
			}
		}

		commit('clearUsers');
		commit('setOrUpdateUsers', Object.values(users)); // Set existing users

		if (newUserIds.length) {
			try {
				const result = await api.loadUsers(newUserIds);
				commit('setOrUpdateUsers', result.data); // Set new users
			} catch (err) {
				dispatch('setError', err);
			}
		}
	},
	clearUsers({ commit }) {
		commit('clearUsers');
	},
	async loadDuties({ commit, dispatch }, date) {
		try {
			const result = await api.loadDuties(date);
			commit('setDuties', result.data);
		} catch (err) {
			dispatch('setError', err);
		}
	},
	async calculateBasicFitness({ dispatch }) {
		try {
			await api.calculateBasicFitness();
		} catch (err) {
			dispatch('setError', err);
		}
	},

	setError({ commit }, err) {
		if (err && err.response && err.response.data) {
			commit('setError', { message: err.response.data.message });
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
